import dayjs from 'dayjs';

export function isValidDayjs(val: any): boolean {
    let res = true;
    if (val) {
        const dd = dayjs(val);
        return dayjs.isDayjs(dd);
    }

    return res;
}

export function isValidDate(date: any): boolean {
    if (typeof date === 'string') return !isNaN(Date.parse(date));
    return date instanceof Date && !isNaN(date.valueOf());
}

export function getISOStringWithOutLocalization(date: Date) {
    if (date.getHours() === 0) {
        date.setUTCHours(0, 0, 0, 0);
        date.setUTCDate(date.getDate() + 1);
    }
    else {
        date.setUTCHours(0, 0, 0, 0);
    }
    return date.toISOString();
}

export function checkIsValidInputDateFormat(input: string | undefined) {
    return (
        input == null ||
        input.length === 0 ||
        /^\d{2}\.\d{2}\.\d{4}$/.test(input)
    );
}

export function getDateWithoutTime(datetime: Date): Date {
    let date: Date = datetime instanceof Date ? datetime : new Date(datetime);
    if (isValidDate(date)) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
    return datetime;
}

export function formatDate(value: Date, dateFormat?: string): any {

    // https://day.js.org/docs/en/display/format

    if (!dateFormat)
        dateFormat = 'DD.MM.YYYY';

    return dayjs(value).format(dateFormat);
}
export function formatDateTime(value: Date, dateFormat?: string): any {

    // https://day.js.org/docs/en/display/format

    if (!dateFormat && value !== null)
        dateFormat = 'DD.MM.YYYY HH:mm:ss';
    if (value !== null && value !== undefined && dateFormat !== null)
        return dayjs(value).format(dateFormat);
    return '';
}

export function checkIfDateLessThanToday(date: Date) {
    return !(date == null || (dayjs(date) && dayjs(date).diff(getDateWithoutTime(new Date()), 'day') > 0));
}

export function dateDifference(date1: Date, date2: Date) {
    const eq1 = new Date(date1).setHours(0, 0, 0, 0);
    const eq2 = new Date(date2).setHours(0, 0, 0, 0);

    if (eq1 > eq2) return 1;
    if (eq1 === eq2) return 0;
    else return -1;
}

